import React from 'react';
import NavBar from "../NavBar/NavBar";
import {
    NAVBAR_HEIGHT,
    MIN_WINDOW_HEIGHT,
    MIN_WINDOW_WIDTH,
    SCROLL_BAR_WIDTH,
    COURSE_LIST_WIDTH,
    SCHEDULE_FIELD_WIDTH,
    SCHEDULE_FIELD_HEIGHT
} from '../../constants/cssConstants'
import SchedulePanel from "../SchedulePanel/SchedulePanel";
import { DndProvider } from "react-dnd";
import Backend from 'react-dnd-html5-backend';
import LoginPopUp from "../LoginPopUp";
import request from "../../constants/requests";
import RegisterPopUp from "../RegisterPopUp";
import LeftCoursesLists from "../CourseLists/LeftCoursesLists";
import RightCoursesLists from "../CourseLists/RightCoursesLists";
import settingPng from './../../assets/setting.png';
import AddEditPlanPopup from "../PopUp/AddEditPlanPopup";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import DeletePlanPopup from "../DeletePlanPopup";
import CourseCodeContainer from "../CourseCodeContainer";
import trashBinPng from './../../assets/trash.png';
import {CircularProgress} from "@material-ui/core";

// TODO CAPE button
// TODO import major/minor/college into database

const STYLES = {
    scheduleFieldMargin: {
        borderRadius: 15,
        borderStyle: 'solid',
        borderWidth: 5,
        borderColor: "rgba(196, 196, 196, .5)",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box'
    },
    trashBin: {
        height: 20,
        width: 20
    }
}

class PlanningPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            windowHeight: 0,
            windowWidth: 0,
            isLoggedIn: false,
            isRegistering: false,
            plans: [],
            arePlansLoading: true,
            currentPlan: {
                planId: 0,
                majorCoursesList: [],
                minorCoursesList: [],
                geCoursesList: [],
                removedMajorCoursesList: [],
                removedMinorCoursesList: [],
                removedGeCoursesList: [],
                planCoursesList: []
            },
            isCurrentPlanLoading: true,
            isAddPlanPopupOpen: false,
            isAddPlanPopupMandatory: false,
            isEditPlanPopupOpen: false,
            isDeletePopupOpen: false,
            deletePopupPlanId: 0,
            isPlanSaving: false,
            isDragging: false,
            changed: false
        };

        this.googleTokenId = "";
        this.isLoggingIn = false;
        this.token = "";

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onGoogleLogin = this.onGoogleLogin.bind(this);
        this.onRegister = this.onRegister.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onSwitchPlan = this.onSwitchPlan.bind(this);
        this.openAddPlanPopup = this.openAddPlanPopup.bind(this);
        this.closeAddEditPopup = this.closeAddEditPopup.bind(this);
        this.addPlan = this.addPlan.bind(this);
        this.editPlanSetting = this.editPlanSetting.bind(this);
        this.openEditPlanPopup = this.openEditPlanPopup.bind(this);
        this.findCurrentPlan = this.findCurrentPlan.bind(this);
        this.openDeletePlanPopup = this.openDeletePlanPopup.bind(this);
        this.closeDeletePlanPopup = this.closeDeletePlanPopup.bind(this);
        this.deletePlan = this.deletePlan.bind(this);
        this.findIndex = this.findIndex.bind(this);
        this.addCourseToPlan = this.addCourseToPlan.bind(this);
        this.removeCourseFromList = this.removeCourseFromList.bind(this);
        this.moveCourse = this.moveCourse.bind(this);
        this.removeCourseFromPlan = this.removeCourseFromPlan.bind(this);
        this.addCourseToLists = this.addCourseToLists.bind(this);
        this.savePlanCoursesList = this.savePlanCoursesList.bind(this);
        this.getCourseUnit = this.getCourseUnit.bind(this);
        this.getQuarterTotalUnit = this.getQuarterTotalUnit.bind(this);
        this.getYearTotalUnit = this.getYearTotalUnit.bind(this);
        this.getPlanTotalUnit = this.getPlanTotalUnit.bind(this);
        this.setIsDragging = this.setIsDragging.bind(this);
        this.addToPlanCoursesList = this.addToPlanCoursesList.bind(this);
    }

    addToPlanCoursesList(course) {
        const currentPlan = JSON.parse(JSON.stringify(this.state.currentPlan));
        currentPlan.planCoursesList.push(course);
        this.setState({currentPlan: currentPlan})
    }

    setIsDragging(isDragging) {
        this.setState({isDragging: isDragging});
    }

    getPlanTotalUnit(planId) {
        let sum = 0;
        for(let i = 0; i < 4; i++) {
            sum += this.getYearTotalUnit(planId, i);
        }
        return sum;
    }

    getYearTotalUnit(planId, yearIndex) {
        let sum = 0;
        for(let i = yearIndex * 4; i < (yearIndex + 1) * 4; i++) {
            sum += this.getQuarterTotalUnit(planId, i);
        }
        return sum;
    }

    getQuarterTotalUnit(planId, quarterIndex) {
        const plans = JSON.parse(JSON.stringify(this.state.plans));
        const index = this.findIndex(plans, planId);
        if(!plans[index]) {
            return 0;
        }
        const courses = plans[index].coursesList[quarterIndex];
        let sum = 0;
        for(let i = 0; i < courses.length; i++) {
            sum += this.getCourseUnit(courses[i]);
        }
        return sum;
    }

    findCurrentPlan() {
        const currentPlanId = this.state.currentPlan.planId;
        const plans = this.state.plans;
        for(let i = 0; i < plans.length; i++) {
            if(plans[i]._id === currentPlanId) {
                return plans[i];
            }
        }
    }

    // life cycle functions
    componentDidMount() {
        // listen to window resize
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    // self defined functions
    updateWindowDimensions() {
        // check if less than min dimension
        const isLessThanMinHeight = window.innerHeight < MIN_WINDOW_HEIGHT;
        const isLessThanMinWidth = window.innerWidth < MIN_WINDOW_WIDTH;
        // get dimension based on whether less than min dimension
        let height = isLessThanMinHeight ? MIN_WINDOW_HEIGHT : window.innerHeight;
        let width = isLessThanMinWidth ? MIN_WINDOW_WIDTH : window.innerWidth;
        // account for the width of the scroll bar of the browser
        if(isLessThanMinHeight) {
            width -= SCROLL_BAR_WIDTH;
        }
        if(isLessThanMinWidth) {
            height -= SCROLL_BAR_WIDTH;
        }
        // update window dimensions
        this.setState({
            windowHeight: height,
            windowWidth: width
        });
    }

    onGoogleLogin(googleTokenId) {
        this.googleTokenId = googleTokenId;
        this.isLoggingIn = true;

        // verify google token id with server
        const loginRequest = fetch(request.LOGIN(), {
            method: 'POST',
            headers: request.HEADER(),
            body: JSON.stringify({ idToken: this.googleTokenId })
        });
        loginRequest.then(
            (res) => {
                this.isLoggingIn = false;
                res.json().then((response) => {
                    if(response.didLoginSuccess) {
                        // if login successfully, show the screen
                        this.onLogin(response.token);
                    } else {
                        if(!response.isRegistered) {
                            // if not registered, show register screen
                            this.setState({ isRegistering: true });
                        }
                    }
                }, (err) => {
                    console.log(err);
                    console.log("Parsing response body failed.");
                });
            }, (err) => {
                this.isLoggingIn = false;
                console.log(err);
                console.log("Login request failed.")
            }
        );
    }

    onRegister(token) {
        this.onLogin(token);
    }

    onLogin(token) {
        this.setState({ isLoggedIn: true });
        toast("You're logged in now!");
        this.token = token;
        this.getPlans();
    }

    getPlans() {
        fetch(request.GET_PLANS(), {
            method: 'POST',
            headers: request.HEADER(),
            body: JSON.stringify({ token: this.token })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.onLogout();
                }
                if(response.success) {
                    this.setState({ plans: response.plans, arePlansLoading: false }, () => {
                        if(this.state.plans.length > 0) {
                            this.onSwitchPlan(this.state.plans[0]._id);
                        } else {
                            this.openAddPlanPopup(true);
                        }
                    });
                } else {
                    console.log(response.errMsg);
                    console.log("Getting plans failed, retrying in 5 second!");
                    setTimeout(this.getPlans, 5000);
                }
            }, (err) => {
                console.log(err);
                console.log("Parsing response body failed.");
            });
        }).catch((err) => {
            console.log(err);
            console.log("Getting plans failed, retrying in 5 second!");
            setTimeout(this.getPlans, 5000);
        });
    }

    onSwitchPlan(planId, isForceSwitching) {
        // only switch if switching to a different plan
        if(!isForceSwitching && planId === this.state.currentPlan.planId) {
            return;
        }
        // update status
        this.setState({ isCurrentPlanLoading: true });
        // get plan courses lists
        fetch(request.GET_COURSES_LIST(planId), {
            method: 'POST',
            headers: request.HEADER(),
            body: JSON.stringify({ token: this.token })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.onLogout();
                }
                if(response.success) {
                    const currentPlan = {
                        planId: planId,
                        majorCoursesList: response.majorCoursesList,
                        minorCoursesList: response.minorCoursesList,
                        geCoursesList: response.geCoursesList,
                        removedMajorCoursesList: response.removedMajorCoursesList,
                        removedMinorCoursesList: response.removedMinorCoursesList,
                        removedGeCoursesList: response.removedGeCoursesList,
                        planCoursesList: response.planCoursesList
                    };
                    this.setState({ currentPlan: currentPlan, isCurrentPlanLoading: false });
                } else {
                    console.log(response.errMsg);
                    console.log("Getting courses lists failed, retrying in 5 second!");
                    setTimeout(() => { this.onSwitchPlan(planId) }, 5000);
                }
            }, (err) => {
                console.log(err);
                console.log("Parsing response body failed.");
            });
        }).catch((err) => {
            console.log(err);
            console.log("Getting courses lists failed, retrying in 5 second!");
            setTimeout(() => { this.onSwitchPlan(planId) }, 5000);
        });
    }

    onLogout(isActiveLogout) {
        if(isActiveLogout) {
            window.location.reload(true);
        } else {
            toast("We are logging you out in 3 second because\nyour session has expired\nor you logged in from another" +
                " device.")
            setTimeout(() => window.location.reload(true), 3000);
        }
    }

    openAddPlanPopup(isMandatory) {
        this.setState({ isAddPlanPopupOpen: true, isAddPlanPopupMandatory: isMandatory });
    }

    addPlan(plan) {
        const plans = this.state.plans;
        plans.push(plan);
        this.setState({ plans: plans }, () => this.onSwitchPlan(plan._id));
    }

    editPlanSetting(plan) {
        const plans = this.state.plans;
        for(let i = 0; i < plans.length; i++) {
            if(plans[i]._id === plan._id) {
                plans[i] = plan;
                break;
            }
        }
        this.setState({ plans: plans }, () => this.onSwitchPlan(plan._id, true));
    }

    openEditPlanPopup() {
        this.setState({ isEditPlanPopupOpen: true });
    }

    closeAddEditPopup() {
        this.setState({
            isAddPlanPopupOpen: false,
            isEditPlanPopupOpen: false
        })
    }

    openDeletePlanPopup(planId) {
        this.setState({ isDeletePopupOpen: true, deletePopupPlanId: planId });
    }

    closeDeletePlanPopup() {
        this.setState({ isDeletePopupOpen: false, deletePopupPlanId: 0 });
    }

    deletePlan(planId) {
        const plans = this.state.plans;
        let newPlans = [];
        for(let i = 0; i < plans.length; i++) {
            if(plans[i]._id !== planId) {
                newPlans.push(plans[i]);
            }
        }
        this.setState({ plans: newPlans }, () => {
           if(newPlans.length === 0) {
               this.setState({ isCurrentPlanLoading: true });
               this.openAddPlanPopup(true);
           } else {
               this.onSwitchPlan(newPlans[0]._id);
           }
        });

    }

    findIndex(plans, planId) {
        for(let i = 0; i < plans.length; i++) {
            if (plans[i]._id === planId) {
                return i;
            }
        }
    }

    addCourseToPlan(planId, quarterIndex, courseCode) {
        const plans = this.state.plans;
        const index = this.findIndex(plans, planId);
        // add the course to current plan
        plans[index].coursesList[quarterIndex].push(courseCode);
        const coursesListToBeSaved = plans[index].coursesList;
        this.setState({plans: plans})
        // remove the course from current plan's three lists
        this.removeCourseFromList(courseCode);

        // auto save plan in 2 second
        setTimeout(() => this.savePlanCoursesList(planId, coursesListToBeSaved), 2000);
    }

    moveCourse(planId, fromQuarterIndex, toQuarterIndex, courseCode) {

    }

    removeCourseFromPlan(planId, quarterIndex, courseCode, isToQuarter) {
        const plans = this.state.plans;
        const index = this.findIndex(plans, planId);
        // remove the course from the current plan
        const quarterCoursesList = plans[index].coursesList[quarterIndex];
        quarterCoursesList.splice(quarterCoursesList.indexOf(courseCode), 1);
        plans[index].coursesList[quarterIndex] = quarterCoursesList;
        const coursesListToBeSaved = plans[index].coursesList;
        this.setState({plans: plans});
        // add it back to the current plan's three lists if the destination is not a quarter
        if(!isToQuarter) {
            this.addCourseToLists(courseCode);

            // only save when not moved to quarter, since move to quarter is handled by add course to plan
            // auto save plan in 2 second
            setTimeout(() => this.savePlanCoursesList(planId, coursesListToBeSaved), 2000);
        }
    }

    addCourseToLists(courseCode) {
        const currentPlan = this.state.currentPlan;
        for(let i = 0; i < currentPlan.removedMajorCoursesList.length; i++) {
            if(currentPlan.removedMajorCoursesList[i].course_code === courseCode) {
                currentPlan.majorCoursesList.push(currentPlan.removedMajorCoursesList[i]);
                currentPlan.removedMajorCoursesList.splice(i, 1);
                break;
            }
        }
        for(let i = 0; i < currentPlan.removedMinorCoursesList.length; i++) {
            if(currentPlan.removedMinorCoursesList[i].course_code === courseCode) {
                currentPlan.minorCoursesList.push(currentPlan.removedMinorCoursesList[i]);
                currentPlan.removedMinorCoursesList.splice(i, 1);
                break;
            }
        }
        for(let i = 0; i < currentPlan.removedGeCoursesList.length; i++) {
            if(currentPlan.removedGeCoursesList[i].course_code === courseCode) {
                currentPlan.geCoursesList.push(currentPlan.removedGeCoursesList[i]);
                currentPlan.removedGeCoursesList.splice(i, 1);
                break;
            }
        }
        this.setState({currentPlan: currentPlan, changed: !this.state.changed});
    }

    removeCourseFromList(courseCode) {
        const currentPlan = this.state.currentPlan;
        for(let i = 0; i < currentPlan.majorCoursesList.length; i++) {
            if(currentPlan.majorCoursesList[i].course_code === courseCode) {
                currentPlan.removedMajorCoursesList.push(currentPlan.majorCoursesList[i]);
                currentPlan.majorCoursesList.splice(i, 1);
                break;
            }
        }
        for(let i = 0; i < currentPlan.minorCoursesList.length; i++) {
            if(currentPlan.minorCoursesList[i].course_code === courseCode) {
                currentPlan.removedMinorCoursesList.push(currentPlan.minorCoursesList[i]);
                currentPlan.minorCoursesList.splice(i, 1);
                break;
            }
        }
        for(let i = 0; i < currentPlan.geCoursesList.length; i++) {
            if(currentPlan.geCoursesList[i].course_code === courseCode) {
                currentPlan.removedGeCoursesList.push(currentPlan.geCoursesList[i]);
                currentPlan.geCoursesList.splice(i, 1);
                break;
            }
        }
        this.setState({currentPlan: currentPlan, changed: !this.state.changed});
    }

    savePlanCoursesList(planId, coursesList) {
        this.setState({ isPlanSaving: true });
        fetch(request.SAVE_PLAN_COURSES_LIST(planId), {
            method: 'POST',
            headers: request.HEADER(),
            body: JSON.stringify({
                token: this.token,
                courses: coursesList
            })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.onLogout();
                }
                if(!response.didSaveSucceed) {
                    toast("Plan auto-save failed.");
                }
                this.setState({isPlanSaving: false});
            }, (err) => {
                console.log(err);
                console.log("Parsing response body failed.");
                this.setState({isPlanSaving: false});
            });
        }).catch((err) => {
            console.log(err);
            console.log("Plan saving failed.");
            toast("Plan auto-save failed.");
            this.setState({isPlanSaving: false});
        });
    }

    getCourseUnit(courseCode) {
        const currentPlan = JSON.parse(JSON.stringify(this.state.currentPlan));
        const majorCourseList = currentPlan.majorCoursesList;
        if(!majorCourseList) {
            return 0;
        }
        for(let i = 0; i < majorCourseList.length; i++) {
            if(majorCourseList[i].course_code === courseCode) {
                return majorCourseList[i].unit;
            }
        }
        const minorCourseList = currentPlan.minorCoursesList;
        if(!minorCourseList) {
            return 0;
        }
        for(let i = 0; i < minorCourseList.length; i++) {
            if(minorCourseList[i].course_code === courseCode) {
                return minorCourseList[i].unit;
            }
        }
        const geCourseList = currentPlan.geCoursesList;
        if(!geCourseList) {
            return 0;
        }
        for(let i = 0; i < geCourseList.length; i++) {
            if(geCourseList[i].course_code === courseCode) {
                return geCourseList[i].unit;
            }
        }
        const removedMajorCourseList = currentPlan.removedMajorCoursesList;
        if(!removedMajorCourseList) {
            return 0;
        }
        for(let i = 0; i < removedMajorCourseList.length; i++) {
            if(removedMajorCourseList[i].course_code === courseCode) {
                return removedMajorCourseList[i].unit;
            }
        }
        const removedMinorCourseList = currentPlan.removedMinorCoursesList;
        if(!removedMinorCourseList) {
            return 0;
        }
        for(let i = 0; i < removedMinorCourseList.length; i++) {
            if(removedMinorCourseList[i].course_code === courseCode) {
                return removedMinorCourseList[i].unit;
            }
        }
        const removedGeCourseList = currentPlan.removedGeCoursesList;
        if(!removedGeCourseList) {
            return 0;
        }
        for(let i = 0; i < removedGeCourseList.length; i++) {
            if(removedGeCourseList[i].course_code === courseCode) {
                return removedGeCourseList[i].unit;
            }
        }
        const planCoursesList = currentPlan.planCoursesList;
        if(!planCoursesList) {
            return 0;
        }
        for(let i = 0; i < planCoursesList.length; i++) {
            if(planCoursesList[i].course_code === courseCode) {
                return planCoursesList[i].unit;
            }
        }
        return 0;
    }


    render() {
        const NON_NAVBAR_HEIGHT = this.state.windowHeight - NAVBAR_HEIGHT;
        const SCHEDULE_FIELD_HORIZONTAL_MARGIN = (this.state.windowWidth - 2 * COURSE_LIST_WIDTH - SCHEDULE_FIELD_WIDTH) / 2;
        const SCHEDULE_FIELD_VERTICAL_MARGIN = (NON_NAVBAR_HEIGHT - SCHEDULE_FIELD_HEIGHT) / 2;
        const styles = {
            app: {
                height: this.state.windowHeight,
                width: this.state.windowWidth,
                backgroundColor: "red"
            },
            scheduleFieldHorizontalMargin: {
                height: NON_NAVBAR_HEIGHT,
                width: SCHEDULE_FIELD_HORIZONTAL_MARGIN
            },
            scheduleFieldVerticalMargin: {
                height: SCHEDULE_FIELD_VERTICAL_MARGIN,
                width: SCHEDULE_FIELD_WIDTH
            },
            schedulePanelMiddle: {
                height: NON_NAVBAR_HEIGHT,
                WIDTH: SCHEDULE_FIELD_WIDTH
            },
            schedulePanel: {
                height: NON_NAVBAR_HEIGHT,
                width: SCHEDULE_FIELD_WIDTH + 2 * SCHEDULE_FIELD_HORIZONTAL_MARGIN,
                backgroundColor: "#CCF0FF",
                display: 'flex',
                flexDirection: 'row',
                position: 'relative'
            }
        };
        const MARGIN_CONTENT = this.state.isDragging ? <img src={trashBinPng} style={ STYLES.trashBin } /> : null;
        if(this.state.isDragging) {
            styles.scheduleFieldHorizontalMargin = Object.assign(styles.scheduleFieldHorizontalMargin, STYLES.scheduleFieldMargin);
            styles.scheduleFieldVerticalMargin = Object.assign(styles.scheduleFieldVerticalMargin, STYLES.scheduleFieldMargin);
        }
        return(
            <DndProvider backend={ Backend }>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable
                    pauseOnHover
                />
                <div style={ styles.app }>
                    { !this.state.isLoggedIn && !this.state.isRegistering &&
                        <LoginPopUp
                            isLoggingIn={ this.isLoggingIn }
                            onGoogleLogin={ this.onGoogleLogin }
                        />
                    }
                    {
                        !this.state.isLoggedIn && this.state.isRegistering &&
                            <RegisterPopUp
                                googleTokenId={ this.googleTokenId }
                                onRegister={ this.onRegister }
                            />
                    }
                    {
                        (this.state.isAddPlanPopupOpen || this.state.isEditPlanPopupOpen) &&
                            <AddEditPlanPopup
                                isMandatory={ this.state.isAddPlanPopupMandatory }
                                onClose={ this.closeAddEditPopup }
                                addPlan={ this.addPlan }
                                editPlan={ this.editPlanSetting }
                                originalPlan={ this.findCurrentPlan() }
                                token={ this.token }
                                onLogout={ this.onLogout }
                                isAddPlan={ this.state.isAddPlanPopupOpen }
                            />
                    }
                    {
                        this.state.isDeletePopupOpen
                            && <DeletePlanPopup planId={ this.state.deletePopupPlanId } token={ this.token }
                                                closePopup={ this.closeDeletePlanPopup } onLogout={ this.onLogout }
                                                onDeletePlan={ this.deletePlan }
                            />
                    }
                    <NavBar
                        currentPlanId={ this.state.currentPlan.planId }
                        width={ this.state.windowWidth }
                        plans={ this.state.plans }
                        onSwitchPlan={ this.onSwitchPlan }
                        openAddPlanPopup={ () => { this.openAddPlanPopup(false) } }
                        onLogout={ this.onLogout }
                        openDeletePlanPopup={ this.openDeletePlanPopup }
                        searchResultHeight={ NON_NAVBAR_HEIGHT }
                        token={this.token}
                        addToPlanCoursesList={this.addToPlanCoursesList}
                        isLoading={!this.state.isLoggedIn}
                    />
                    <div
                        style={{
                            height: NON_NAVBAR_HEIGHT,
                            width: this.state.windowWidth,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <LeftCoursesLists
                            height={ NON_NAVBAR_HEIGHT }
                            majorCoursesList={ this.state.isCurrentPlanLoading ? [] : this.state.currentPlan.majorCoursesList }
                            changed={this.state.changed}
                        />
                        <div style={ styles.schedulePanel } >
                            <CourseCodeContainer>
                                <div style={ styles.scheduleFieldHorizontalMargin }>
                                    { MARGIN_CONTENT }
                                </div>
                            </CourseCodeContainer>
                            <div style={ styles.schedulePanelMiddle } >
                                <CourseCodeContainer>
                                    <div style={ styles.scheduleFieldVerticalMargin }>
                                        { MARGIN_CONTENT }
                                    </div>
                                </CourseCodeContainer>
                                <SchedulePanel
                                    plan={ this.findCurrentPlan() }
                                    isLoading={this.state.isCurrentPlanLoading}
                                    addCourseToPlan={this.addCourseToPlan}
                                    moveCourse={this.moveCourse}
                                    removeCourseFromPlan={this.removeCourseFromPlan}
                                    getUnits={{
                                        getCourseUnit: this.getCourseUnit,
                                        getQuarterTotalUnit: this.getQuarterTotalUnit,
                                        getYearTotalUnit: this.getYearTotalUnit,
                                        getPlanTotalUnit: this.getPlanTotalUnit
                                    }}
                                    setIsDragging={this.setIsDragging}
                                />
                                <CourseCodeContainer>
                                    <div style={ styles.scheduleFieldVerticalMargin }>
                                        { MARGIN_CONTENT }
                                    </div>
                                </CourseCodeContainer>
                            </div>
                            <CourseCodeContainer>
                                <div style={ styles.scheduleFieldHorizontalMargin }>
                                    { MARGIN_CONTENT }
                                </div>
                            </CourseCodeContainer>
                            <div style={{ top: 10, right: 10, position: 'absolute' }}>
                                <img onClick={ this.openEditPlanPopup } src={ settingPng }
                                     style={{ width: 20, height: 20 }} />
                            </div>
                            {
                                this.state.isPlanSaving &&
                                <div style={{ position: 'absolute', top: 10, right: 80, display: 'flex' }}>
                                    <CircularProgress color={"secondary"} size={18} />
                                    <div style={{marginLeft: 8, fontWeight: 'bold'}}>auto saving...</div>
                                </div>
                            }
                        </div>
                        <RightCoursesLists
                            height={ NON_NAVBAR_HEIGHT }
                            geCoursesList={ this.state.isCurrentPlanLoading ? [] : this.state.currentPlan.geCoursesList }
                            minorCoursesList={ this.state.isCurrentPlanLoading ? [] : this.state.currentPlan.minorCoursesList }
                            changed={this.state.changed}
                        />
                    </div>
                </div>
            </DndProvider>
        );
    }
}

export default PlanningPage;